<template>
    <Modal name="newReport" class="newShared" v-bind="$attrs" :key='id' size="w-screen h-screen md:h-auto md:max-w-4xl md:w-9/12 md:rounded-3xl">
        <template v-slot:header>
            <h1 v-if="!editMode">{{ $t('create_shared') }}</h1>
            <h1 v-else>{{ $t('edit_shared') }}</h1>
        </template>
        <template v-slot:body>
            <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-x-8">
                <div class="col-start-1 order-1 sm:order-2 row-start-2 sm:row-start-1">
                    <div class="form">
                        <label>{{ $tc('report', 1) }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_myown_report')"></feather></label>
                        <multiselect :multiple="false" open-direction="bottom" group-label="name" v-model="reportSelected" @select="reportChanged" group-values="report" :options="restrictedReportsTypeList" label="name" track-by="id" :close-on-select="true" :show-labels="false" placeholder="Select"></multiselect>
                    </div>
                </div>
                <div class="col-start-1 order-2 sm:order-1 sm:col-start-2 row-start-1">
                    <div class="form">
                        <label>{{ $tc('recipient', 2) }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_recipients')"></feather></label>
                        <div class="recipients-list" style="display: flex">
                          <multiselect
                              v-model="recipients.selected"
                              open-direction="bottom"
                              :multiple="true"
                              label="name"
                              track-by="email"
                              :options="filterUsed(recipients.list)"
                              @search-change="findUsers"
                              :loading="loadingUsers"
                              :show-labels="false"
                              :placeholder="$t('add_recipient')"></multiselect>
                          <multiselect
                              name="permission-level"
                              v-model="permissionLevel"
                              open-direction="bottom"
                              :options="['can view','can edit']"
                              :searchable="false"
                              :close-on-select="true"
                              :show-labels="false"
                              :placeholder="$t('select')">
                          </multiselect>
                          <button class="transition btn-report pureNavy my-2 uppercase text-bold mx-2" @click="addUsers">{{ $t('add') }}</button>
                        </div>
                      <ul class="mt-2">
                        <li v-for="column in recipients.used" :key="column.name" class="flex justify-between items-center mt-2">
                          <div class="flex items-center">
                            <span>{{column.name}}</span>
                          </div>
                          <div class="flex permission-element">
                            <multiselect v-model="column.permission" :refresh="refresh" @select="updatePermission($event, column)" @remove="removePermission($event, column)" label="label" track-by="value" :multiple="false" :options="permissions" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
                            <button type="button" @click="removePermission($event, column)" aria-label="Close modal">
                              <feather type="x" />
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="btn btn-primary submit" :class="!isValid ? 'disabled' : ''" @click="submit">
                <feather size="24px" type="send" /> {{ $t('submit') }}
            </div>
        </template>
    </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '../modules/modals/components/Modal'

export default {
    name: 'modalNewShared',
    components: {
        Modal,
    },
    data(){
        return {
            id: null,
            title: '',
            loadingUsers: false,
            loadingUsedUsers: false,
            reportSelected: null,
            permissionLevel: 'can view',
            recipients: {
                selected:[],
                list: [],
                used: []
            },
            refresh: false,
            name_error: false,
            permissions: [
              {value: '0', name: 'can view', label: this.$t('can_view', 1)},
              {value: '1', name: 'can edit', label: this.$t('can_edit', 1)}
          ]
        }
    },
    computed: {
        ...mapGetters([
            'newReport',
            'reportsTypeList',
            'users',
            'usersToShareWith',
            'sharedUsers',
            'schedules',
            'calendarAttributes',
            'scheduleOptions',
            'getUser',
            'shares',
            'restrictedReportsTypeList'
        ]),
        editMode() {
            if(this.id){
                return true
            } else {
                return false
            }
        },
        isValid(){
            return this.editMode ? this.title.trim().length && this.recipients.used.length && !this.name_error : this.reportSelected && this.recipients.used.length && !this.name_error;
        }
    },
    methods: {
        ...mapMutations({
            setNewReportItem: 'setNewReportItem',
        }),
        ...mapActions({
            saveShared: 'saveShared',
            editShared: 'editShared',
            getUsers: 'getUsers',
            getSharedReportUsers: 'getSharedReportUsers',
            deleteReport: 'deleteReport'
        }),
        submit() {
            if(!this.isValid) {
                return
            }
/*
            if(this.id) {
                const payload = {
                    id: this.id,
                    name: this.title,
                    users: JSON.stringify(this.recipients.used)
                }
                this.editShared(payload)
                this.$attrs.close()
                return
            }*/

            let payload = { ...this.reportSelected }

            payload.name = this.reportSelected.name
            payload.schedule = []
            payload.shared = this.reportSelected.user_id
            payload.sharedReport = this.reportSelected.id
            payload.service = payload.service.name

            delete payload.user_name

            if(this.id) {
              payload.id = this.id
              payload.users = JSON.stringify(this.recipients.used)
              this.editShared(payload)
            }
            else{
              delete payload.id
              this.recipients.used.forEach(recipient => {
                payload.user_id = recipient.id
                payload.editPermission = recipient.permission.value
                this.saveShared(payload)
              });
            }
            this.$attrs.close()
        },
        findUsers(query){
            return new Promise((resolve) => {
                this.loadingUsers = true
                this.getUsers(query).then(()=> {
                    this.recipients.list = this.filterUsed(this.usersToShareWith)
                    this.loadingUsers = false
                    resolve()
                })
            })  
        },
        filterUsed(users) {
            return users.filter((user) => {
              return this.recipients.used.filter((usedUser) => user.email === usedUser.email).length === 0
            })
        },
        addUsers(){
          this.recipients.selected.forEach(user => {
            user.permission = this.permissionLevel == 'can edit' ? this.permissions[1] : this.permissions[0];
            this.recipients.used.push(user);
          })
          this.recipients.selected = [];

        },
        reportChanged(){
          return new Promise((resolve) => {
            this.loadingUsedUsers = true
            this.getSharedReportUsers(this.reportSelected.id).then(()=> {

              this.recipients.used = this.sharedUsers

              this.recipients.used.forEach(
                  (user, index) =>
                      (user.permission = user.permission === '1' ? this.permissions[1] : this.permissions[0])
              );

              this.loadingUsedUsers = false
              resolve()
            })
            const found = this.shares.find(report => report.shared_report_id === this.reportSelected.id)
            if(typeof found === 'object'){
              this.title = found.name
              this.id = found.id
              return
            }
            this.id = null
          })
        },
        validate() {
            const found = this.shares.find(report => report.name === this.title)
            this.name_error = false
            
            if(found !== undefined) {
                if(this.editMode && found.id === this.id) {
                    return
                }
                this.name_error = true
            }
        },
      removePermission(value, column){
        //const found = this.recipients.used.find(user => user.id === this.column.id)
        const filtersList = this.recipients.used.filter(user => user.id !== column.id)
        this.recipients.used = filtersList;
      },
      updatePermission(value, column){
        this.refresh = !this.refresh
        /*
        const tempAddArray = [...this.additionalGroupBy ? this.additionalGroupBy : '']
        const index = this.additionalGroupBy.findIndex(item => item.name == column.name)
        if (index != -1) {
          let el = tempAddArray[index]
          if (Array.isArray(el.additionalGroupBy)) {
            let aggIndex = el.additionalGroupBy.findIndex(item => item.model == value.model)
            if (aggIndex == -1) {
              el.additionalGroupBy.push(value)
            }
          }
          tempAddArray.splice(index, 1, el)
        } else {
          let el = {
            name: column.name,
            type: column.type,
            label: column.name,
            additionalGroupBy: [value]
          }
          tempAddArray.push(el)
        }
        this.setNewReportItem({additionalGroupBy: tempAddArray})
        */
      },
    },
    mounted() {
        this.findUsers('').then(() => {
            if(this.$attrs.id) {
                this.id = this.$attrs.id
                const shared = this.shares.find(shared => shared.id === this.id)
                if(shared) {
                    this.title = shared.name
                    const sharedReport = this.restrictedReportsTypeList[0].report.find(report => report.id === shared.shared_report_id)
                    if(sharedReport){
                      this.reportSelected = sharedReport;

                      this.getSharedReportUsers(this.reportSelected.id).then(()=> {

                        this.recipients.used = this.sharedUsers

                        this.recipients.used.forEach(
                            (user, index) =>
                                (user.permission = user.permission === '1' ? this.permissions[1] : this.permissions[0])
                        );

                        this.loadingUsedUsers = false
                        resolve()
                      })

                    }

                    /*
                    shared.user_names.forEach(user => {
                        const foundUser = this.recipients.list.find(recipient => recipient.name === user)
                        //this.recipients.selected.push(foundUser)
                        console.log(foundUser)
                        foundUser.permission = foundUser.permission.value === '1' ? this.permissions[1] : this.permissions[0];
                        this.recipients.used.push(foundUser)
                    })*/
                }
            }
        })
    }
}
</script>

<style lang="sass" scoped>
h1
    font-size: 25px!important
label
    font-weight: 700
    font-size: 17px
    margin-bottom: 4px!important
input, select, textarea
    border: 1px solid #F0F1F3!important
    border-radius: 7px
    width: 100%
input[type='checkbox']
    min-width: 25px
    width: initial!important
    height: 25px
    min-height: initial!important
.form
    margin-bottom: 1rem
.error
    color: #CC0000
.noedit
    cursor: not-allowed
.recipients-list
  display: flex
.permission-element
  min-width: 130px
  button
    padding: 10px
.newShared
  .modal
    min-width: 900px
</style>

<style lang="sass">
$buttonWidth: calc(85px + 1rem)
$modalPadding: 20px
.recipients-list
  .multiselect
    width: calc((100vw - 2 * $modalPadding - $buttonWidth)/2)
    @media screen and (min-width: 640px) and (max-width: 767px)
      width: calc(((100vw - 2 * $modalPadding - 2rem)/2 - $buttonWidth)/2)
    @media screen and (min-width: 768px)
      width: calc(((75vw - 2 * $modalPadding - 2rem)/2 - $buttonWidth)/2)
      max-width: calc(((56rem - 2 * $modalPadding - 2rem)/2 - $buttonWidth)/2)
  .multiselect__content-wrapper
    position: fixed
    width: inherit
    max-width: inherit
</style>